export default function filter() {
	let listProducts = $('.listProducts');
	let productFilter = $('.productSearch');

	let form = $('.filterProduct .form');

	function filterProducts(form, page = null) {
		$('.modalLoader').show();

		grecaptcha.ready(function () {
			grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
				action: 'submit'
			}).then(function (token) {

				$.ajax({
					type: form.attr('method'),
					url: form.attr('action'),
					data: form.serialize() + (page ? "&p=" + page + "&l=9" : null)+'&gRecaptchaResponse='+ token,
					dataType: "json",
					success: function (data) {
						$('.modalLoader').hide();
						let valSearch = '';
						let inputSearch = $('.filterProduct .inputSearch');
						if (form.find('.inputSearch').val().length > 0) {
							valSearch = `${jsi18n.to} <span class="colorPrimary">"${inputSearch.val()}"</span>`;
						} else {
							inputSearch.val('');
						}

						let content = `<h2 class="productSearch__return">${jsi18n.have_found} ${data.total} ${jsi18n.results} ${valSearch}</h2><div class="row">`;

						$.each(data.contents, function (key, el) {
							// content += `<div class="productSearch__iten">
							// 		<div class="productSearch__flex">
							// 			<div class="productSearch__blockImage">
							// 				<div class="productSearch__image" style="background-image: url('${el.image}')"></div>
							// 			</div>
							// 			<div class="productSearch__blockText">
							// 				<p class="productSearch__name">${el.name}</p>
							// 				<p class="productSearch__cod">${el.code}</p>
							// 				<p class="productSearch__description">${el.description}</p>
							// 				<a href="${el.link}" class="productSearch__btn bgPrimary">Ver mais</a>
							// 			</div>
							// 		</div>
							// 	</div>`;

							content += `<div class="col-md-4 col-6">
									<div class="listProducts__iten">
										<a href="${el.link}">
											<div class="listProducts__blockImage">
												${el.text_launch}
												<div class="listProducts__image ${el.launch}" style="background-image: url('${el.image}')"></div>
											</div>
											<p class="listProducts__title colorPrimary">${el.name}</p>
											<p class="listProducts__cod">${jsi18n.code} ${el.code}</p>
										</a>
									</div>
								</div>`;
						})
						content += `</div>`;
						listProducts.hide();
						productFilter.html(content).fadeIn();
						$('#productList .productPagination').html(data.pagination);
					}
				});

			});
		});

	}

	$('.formSearch').submit(function (e) {
		e.preventDefault();
		filterProducts($(this), 1);
	})

	$('.formSearch input[type="checkbox"]').change(function () {
		filterProducts($('.formSearch'), 1);
	})

	$('.perpage-select').change(function (event) {
		if ($(this).val()) {
			location.href = $(this).val();
		}
	});
	$('#productList').on('click', '.pager.filter a', function (e) {
		e.preventDefault();
		var page = $(this).data('page');
		filterProducts($('.formSearch'), page);
	});
	$('.filterProduct__btnClear').on('click', function () {
		$("form").each(function () {
			$(this).trigger('reset');
		});
		filterProducts($('.formSearch'), 1);
	});
}